import 'bootstrap/dist/css/bootstrap.min.css';
import "./src/styles/fonts.css";
import "./src/styles/main.css";
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider;